import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const GenericDeclinedSimple: Illustration = (props) => (
  <svg viewBox="0 0 187 125" {...illustrationProps(props, { width: 187 })}>
    <path
      fill="#FF9494"
      d="M27.179 4.517c-2.2 6.811-4.388 13.62-6.587 20.43l-.949 2.934c-.559 1.742 2.12 2.535 2.682.787 2.2-6.811 4.388-13.62 6.588-20.43l.948-2.934c.559-1.742-2.119-2.535-2.682-.787Z"
    />
    <path
      fill="#FF9494"
      d="M13.806 14.604c6.654 2.006 13.302 4.007 19.955 6.012.93.28 1.86.558 2.787.843 1.72.515 2.559-2.201.836-2.726-6.654-2.006-13.302-4.007-19.955-6.013-.93-.279-1.86-.557-2.787-.843-1.72-.515-2.558 2.202-.835 2.727Z"
    />
    <path
      fill="#FF9494"
      d="M34.954 8.997 16.094 19.05c-.902.485-1.805.96-2.706 1.444-1.613.864-.34 3.362 1.273 2.498l18.861-10.053c.901-.485 1.805-.96 2.706-1.445 1.613-.864.34-3.361-1.274-2.497Z"
    />
    <path
      fill="#FF9494"
      d="M18.612 6.718c3.204 6.198 6.397 12.398 9.601 18.596l1.34 2.602c.825 1.606 3.325.265 2.5-1.34-3.194-6.2-6.398-12.399-9.591-18.6l-1.34-2.601c-.825-1.605-3.325-.265-2.5 1.34l-.01.003Z"
    />
    <path
      fill="#FFB3B3"
      fillRule="evenodd"
      d="M154.09 119.943a6.859 6.859 0 1 0 0-13.716 6.86 6.86 0 0 0-6.861 6.858 6.86 6.86 0 0 0 6.861 6.858Zm0 3.227c5.573 0 10.09-4.515 10.09-10.085 0-5.57-4.517-10.085-10.09-10.085-5.572 0-10.09 4.515-10.09 10.085 0 5.57 4.518 10.085 10.09 10.085Z"
      clipRule="evenodd"
    />
    <path
      fill="#FFB3B3"
      d="M170.008 44.608a91.55 91.55 0 0 1-1.797-4.245c-.371-.964.034-1.981.967-2.43.879-.423 2.078.062 2.432.965a90.68 90.68 0 0 0 1.774 4.195c1.468-.657 2.944-1.303 4.443-1.883.964-.371 1.983.034 2.432.966.423.878-.063 2.077-.967 2.43-1.482.574-2.941 1.212-4.393 1.861.661 1.466 1.335 2.927 2.071 4.36.468.917-.114 2.02-.967 2.43-.941.457-1.99-.11-2.432-.966-.728-1.41-1.394-2.857-2.048-4.308a92.482 92.482 0 0 0-4.166 1.98c-.918.468-2.022-.113-2.432-.965-.456-.941.11-1.99.967-2.431a86.732 86.732 0 0 1 4.116-1.96ZM18.384 79.394c-.205-1.117-.9-2.188-1.936-2.802-.998-.586-2.376-.668-3.52-.54-.744.082-1.389.256-1.986.687-.46.33-.782.787-.987 1.29-.548.202-.88.67-.939 1.264-.108 1.063.342 2.134 1.085 2.94.284.476.665.87 1.213 1.117.587.265 1.203.43 1.838.521 1.35.193 2.954.275 4.049-.631.43-.357.645-.815.714-1.31.078-.11.146-.22.205-.33.352-.713.401-1.437.264-2.206Zm-5.173.302s.02-.018 0 0Z"
    />
    <circle cx="93" cy="62" r="48" fill="#FF9494" />
    <path
      fill="#fff"
      d="M77.828 42.672a4 4 0 1 0-5.656 5.656L88.093 64.25 72.172 80.172a4 4 0 1 0 5.656 5.656L93.75 69.907l15.922 15.921a3.999 3.999 0 0 0 5.656 0 3.998 3.998 0 0 0 0-5.656L99.407 64.25l15.921-15.922a3.998 3.998 0 0 0 0-5.656 3.999 3.999 0 0 0-5.656 0L93.75 58.593 77.828 42.672Z"
    />
  </svg>
);
